import { mxgraphInstance } from './mxgraphFactory';

/**
 * Model
 */
export const mxCell = mxgraphInstance.mxCell;
export const mxCellPath = mxgraphInstance.mxCellPath;
export const mxGeometry = mxgraphInstance.mxGeometry;
export const mxGraphModel = mxgraphInstance.mxGraphModel;

// /**
//  * mxGraphModel Change
//  */
// export const mxRootChange = mxgraphInstance.mxRootChange;
// export const mxChildChange = mxgraphInstance.mxChildChange;
// export const mxTerminalChange = mxgraphInstance.mxTerminalChange;
// export const mxValueChange = mxgraphInstance.mxValueChange;
// export const mxStyleChange = mxgraphInstance.mxStyleChange;
// export const mxGeometryChange = mxgraphInstance.mxGeometryChange;
// export const mxCollapseChange = mxgraphInstance.mxCollapseChange;
// export const mxVisibleChange = mxgraphInstance.mxVisibleChange;
// export const mxCellAttributeChange = mxgraphInstance.mxCellAttributeChange;